import { apiClient, type AdditionalPaymentCategoryExEntity } from '@/libs/api'

export type FetchAdditionalPaymentCategoryQuery = {
  tenantKey: string
  additionalPaymentCategoryId: number
}

export const fetchAdditionalPaymentCategory = async (
  {
    tenantKey,
    additionalPaymentCategoryId
  }: FetchAdditionalPaymentCategoryQuery,
  signal?: AbortSignal
): Promise<AdditionalPaymentCategoryExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .additional_payment_categories._id(additionalPaymentCategoryId)
    .$get({
      config: {
        signal
      }
    })
  return data
}
